export default {
  "root": "_root_1be8x_1",
  "label": "_label_1be8x_1",
  "caption": "_caption_1be8x_1"
};import "ni:sha-256;YLGXzi9JtVkoPMmZ4kc1Cc4cs2rYiC8gPnOrpJ3RFU8";